import React from "react";
import { useHistory } from "react-router-dom";
import UserContext from "../UserContext";

export default function Logout() {
  const { logout } = React.useContext(UserContext);
  const history = useHistory();
  logout();
  history.push("/login");
  return <div>Logging you out...</div>;
}
